import { render, staticRenderFns } from "./Cliniko.vue?vue&type=template&id=510b57e2&"
import script from "./Cliniko.vue?vue&type=script&lang=js&"
export * from "./Cliniko.vue?vue&type=script&lang=js&"
import style0 from "./Cliniko.vue?vue&type=style&index=0&id=510b57e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports